import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS, OccPromoCouponResponse } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccPromoCouponService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  sendRequest(phoneNumber: string, couponCode: string): Observable<OccPromoCouponResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.promoCoupon);
    const params = { phoneNumber, couponCode };

    return this.http.post<OccPromoCouponResponse>(
      url,
      {},
      {
        params,
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.promoCoupon),
      },
    );
  }
}
